import API from "./api";

// ==========================
// Register Provider
// ==========================

export const registerProvider = async (providerData) => {

    const formData = new FormData();

    // ==========================
    // Basic Details
    // ==========================

    formData.append("ownerName", providerData.ownerName);
    formData.append("phone", providerData.phone);
    formData.append("email", providerData.email);
    formData.append("providerType", providerData.providerType);

    // ==========================
    // Nested Objects
    // ==========================

    formData.append(
        "business",
        JSON.stringify(providerData.business)
    );

    formData.append(
        "address",
        JSON.stringify(providerData.address)
    );

    formData.append(
        "bankDetails",
        JSON.stringify(providerData.bankDetails)
    );

    // ==========================
    // Photos
    // ==========================

    if (providerData.photos.profilePhoto) {

        formData.append(
            "profilePhoto",
            providerData.photos.profilePhoto
        );

    }

    if (providerData.photos.kitchenPhoto) {

        formData.append(
            "kitchenPhoto",
            providerData.photos.kitchenPhoto
        );

    }

    if (providerData.photos.aadhaar) {

        formData.append(
            "aadhaar",
            providerData.photos.aadhaar
        );

    }

    if (providerData.photos.pan) {

        formData.append(
            "pan",
            providerData.photos.pan
        );

    }

    if (providerData.photos.businessLogo) {

        formData.append(
            "businessLogo",
            providerData.photos.businessLogo
        );

    }

    providerData.photos.foodPhotos.forEach((photo) => {

        formData.append(
            "foodPhotos",
            photo
        );

    });

    const response = await API.post(

        "/provider/register",

        formData,

        {

            headers: {

                "Content-Type":
                    "multipart/form-data",

            },

        }

    );

    return response.data;

};

// ==========================
// Get Provider Profile
// ==========================

export const getProviderProfile = async () => {

    const response = await API.get(
        "/provider/profile"
    );

    return response.data;

};

// ==========================
// Check Provider
// ==========================

export const checkProvider = async () => {

    const response = await API.get(
        "/provider/check"
    );

    return response.data;

};

// ==========================
// Dashboard
// ==========================

export const getDashboardStats = async () => {

    const response = await API.get(
        "/provider/dashboard"
    );

    return response.data;

};

// ==========================
// Validate Activation Token
// ==========================

export const validateActivationToken = async (token) => {

    const response = await API.get(
        `/provider/validate-token/${token}`
    );

    return response.data;
};

// ==========================
// Create Password
// ==========================

export const createProviderPassword = async (data) => {

    const response = await API.post(
        "/provider/create-password",
        data
    );

    return response.data;
};